module.exports = __webpack_public_path__ + "static/media/Avenir-Roman.8c6e1556.woff2";